import { Input } from '@/components/atoms/Form/Input';
import { Control, Controller, Form, useForm } from 'react-hook-form';
import React from 'react';
import { computeText } from '@/locales/utils';
import { useIntl } from 'react-intl';

interface ZerosixConfigCreateFormProps {
    control: Control<{ zerosixApiKey: string }>;
    canChangeProvider: boolean;
}

const ZerosixConfigCreateForm = ({ control, canChangeProvider }: ZerosixConfigCreateFormProps) => {
    const intl = useIntl();
    return (
        <Form control={control}>
            <Controller
                control={control}
                name="zerosixApiKey"
                rules={{
                    required: computeText(intl, 'field.required'),
                    validate: (value) =>
                        value && (canChangeProvider || computeText(intl, 'zerosix.error.changeProvider')),
                }}
                render={({ field, fieldState }) => (
                    <Input
                        {...field}
                        labelId="zerosix.apiKey"
                        placeholder="zerosix.apiKey.placeholder"
                        error={fieldState.error?.message}
                    />
                )}
            />
        </Form>
    );
};

export default ZerosixConfigCreateForm;
